import { useEffect } from 'react';
import { useServerNotifications } from '../contexts/ServerNotificationContext';

/**
 * Marks notifications of the given entity types as read when the component mounts.
 * @param {string[]} types - Entity types to mark as read (e.g. ['leave', 'attestation'])
 */
export const useMarkAsReadOnMount = (types) => {
  const { markAsReadByEntityType } = useServerNotifications();

  useEffect(() => {
    if (!types || !types.length) return;
    markAsReadByEntityType(types);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useMarkAsReadOnMount;
